import { render, staticRenderFns } from "./BaseSymbol.vue?vue&type=template&id=ef366840&"
import script from "./BaseSymbol.vue?vue&type=script&lang=js&"
export * from "./BaseSymbol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports